import React, { ReactNode, Suspense, useEffect } from "react";

// redux
import { useDispatch, useSelector } from "react-redux";
import * as layoutConstants from "../constants/layout";

// hooks 
import { RootStateType } from "../store/RootState";
import { useNavigate } from "react-router-dom";
import { isAuthenticate } from "../common/helpers/globalHelpers";
import { clearState } from "../store/slices/tenantSlice";
import Loading from "../features/components/Loading";
import { Preloader, TenantResolver } from "../features/components";
import { FIRM_PATH } from "../constants/storageKeys";
import { getfirmCurrencyList } from "../store/slices/currencyListSlice";
import { ThunkDispatch } from "redux-thunk";
import LayoutConfiguration from "./LayoutConfiguration";
import { useRecoilValue } from "recoil";
import { tenantState } from "../store/recoil/tenant/atoms";
import { isUserAuthorizeToMenu } from "../common/helpers/authorizationHelper";
import { getMenuItems } from "../common/helpers/menu";
import { MenuItemTypes } from "../constants/menu";
import { getNavigationUrl } from "../common/helpers/navigationHelpers";


const Topbar = React.lazy(() => import("./Topbar"));
const LeftSideBar = React.lazy(() => import("./LeftSideBar"));
const Footer = React.lazy(() => import("./Footer"));
const RightSideBar = React.lazy(() => import("./RightSideBar"));

const loading = () => <div />;

interface VerticalLayoutProps {
  children?: ReactNode;
  routeKey: string
}


const VerticalLayout = ({ children, routeKey }: VerticalLayoutProps) => {


  const { isfirmAvailable, isFetching } = useRecoilValue(tenantState);
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const firmPath = localStorage.getItem(FIRM_PATH);

  useEffect(() => {

    
    var isAuth = isAuthenticate();
    if (!isAuth) {
      navigate(getNavigationUrl("/login"));
    }
    //page authentication
    isAuthUser();

  }, [window.location.href]);

  useEffect(() => {
    if (!isFetching) {
      selectFirmCurrencyList();
    }

  }, [isFetching])

  if (isfirmAvailable == false && isFetching != true) { 
    navigate(getNavigationUrl("/404"));
  }

  function findElementRecursive(menuItems: Array<MenuItemTypes>, target: String) {

    for (let node of menuItems) {
      // Eğer şu anki düğüm hedef öğeye eşitse
      if (node.key === target) {
        return node;
      }

      // Eğer children varsa, children'lar arasında recursive arama
      if (node.children && node.children.length > 0) {
        const result: any = findElementRecursive(node.children, target);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  const isAuthUser = () => {
    const menuItems = getMenuItems();

    const menuElement = findElementRecursive(menuItems, routeKey);

    if (menuElement) {

      const isAuth = isUserAuthorizeToMenu(menuElement);

      // if (!isAuth) {
      //   navigate("/404");
      // }

    }
    return true;

  }



  const selectFirmCurrencyList = () => {

    dispatch(getfirmCurrencyList());
  }

  const { sideBarType, sideBarTheme } = useSelector((state: RootStateType) => ({
    sideBarType: state.sideBarlayout.sideBarType,
    sideBarTheme: state.sideBarlayout.sideBarTheme,
  }));

  const isCondensed = sideBarType === layoutConstants.SideBarType.LEFT_SIDEBAR_TYPE_SMALL;
  const isLight = sideBarTheme === layoutConstants.SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT;



  const getContent = () => {

    if (isFetching) {
      return (
        <Loading desc={"Yükleniyor..."}></Loading>
      );
    } else {
      return (
        <Suspense fallback={loading()}>
          <div className="flex wrapper">
            <Suspense fallback={loading()}>
              <LeftSideBar isCondensed={isCondensed} isLight={isLight} />
            </Suspense>

            <div className="page-content">

              <Suspense fallback={loading()}>
                <Topbar />
              </Suspense>

              <main className="flex-grow pl-6 pr-6 pt-0 pb-0 ">
                <Suspense fallback={<Preloader />}>
                  {children}
                </Suspense>
              </main>

              <Footer />
            </div>
          </div>

          <Suspense fallback={loading()}>
            <RightSideBar />
          </Suspense>
        </Suspense>
      );
    }
  }

  return (
    <>
      <LayoutConfiguration />
      <TenantResolver />

      {getContent()}
    </>
  );
};

export default VerticalLayout;
